import React from 'react';
import { Button } from 'tuui';
import { AlertOIcon } from 'taboola-ultimate-ui';
import { CONVERSION_CREATION_PATH } from 'modules/PixelTester/config/pixelTesterConsts';
import { GTM_EVENTS } from 'modules/taboola-common-frontend-modules/gtmTracker';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './unrecognisedEventDescription.module.scss';

export const UnrecognisedEventDescription = () => {
    return (
        <div className={styles['container']}>
            <div className={styles['error-text']}>
                <div className={styles['icon-title-container']}>
                    <AlertOIcon className={styles['icon']} />
                    <FormattedMessage
                        id="pixel.tester.unrecognised.event.title"
                        defaultMessage="Unrecognised Event"
                        className={styles['title']}
                    />
                </div>
                <FormattedMessage
                    id="pixel.tester.unrecognised.event.subtitle"
                    defaultMessage="This event isn’t currently defined as a conversion."
                    className={styles['subtitle']}
                />
            </div>
            <Button
                id="PIXEL_TESTER_CREATE_CONVERSION_BTN"
                className={styles['button']}
                variant={Button.variant.ghost}
                onClick={() => window.open(`${window.location.origin}${CONVERSION_CREATION_PATH}`, '_blank')}
                data-metrics-event-name={GTM_EVENTS.USABILITY}
                data-metrics-component={UnrecognisedEventDescription.name}
                data-metrics-value="PIXEL_TESTER_UNRECOGNIZED_EVENT_CREATE_CONVERSION"
            >
                <FormattedMessage
                    id="pixel.tester.unrecognised.event.create.conversion.button.label"
                    defaultMessage="Create Conversion"
                />
            </Button>
        </div>
    );
};
